export const MemberAccessLevel = {
  HR: "Recruiter",
  HM: "Hiring Manager",
  Admin: "Admin",
  B: "Admin",
};
